import React from 'react';
import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'iconButtonVariant',
})(({ theme, iconButtonVariant }) => {
  const variants = {
    default: {
      transition: 'all 0.2s ease',
      '&:hover': {
        transform: 'scale(1.1)',
      },
    },
    action: {
      borderRadius: theme.spacing(1),
      padding: theme.spacing(0.75),
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        transform: 'scale(1.1)',
      },
    },
    table: {
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(0.5),
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: theme.palette.primary[50],
        transform: 'scale(1.15)',
      },
    },
    danger: {
      borderRadius: theme.spacing(1),
      padding: theme.spacing(0.75),
      transition: 'all 0.2s ease',
      color: '#E57373', // Softer red color instead of bright red
      '&:hover': {
        backgroundColor: theme.palette.error[50],
        color: theme.palette.error.main, // Slightly brighter on hover
        transform: 'scale(1.1)',
      },
    },
    success: {
      borderRadius: theme.spacing(1),
      padding: theme.spacing(0.75),
      transition: 'all 0.2s ease',
      color: theme.palette.success.main,
      '&:hover': {
        backgroundColor: theme.palette.success[50],
        transform: 'scale(1.1)',
      },
    },
    primary: {
      borderRadius: theme.spacing(1),
      padding: theme.spacing(0.75),
      transition: 'all 0.2s ease',
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary[50],
        transform: 'scale(1.1)',
      },
    },
  };

  return variants[iconButtonVariant] || variants.default;
});

const EasyCheckIconButton = ({
  children,
  variant = 'default',
  color = 'default',
  size = 'medium',
  disabled = false,
  onClick,
  ...props
}) => {
  return (
    <StyledIconButton
      iconButtonVariant={variant}
      color={color}
      size={size}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </StyledIconButton>
  );
};

EasyCheckIconButton.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['default', 'action', 'table', 'danger', 'success', 'primary']),
  color: PropTypes.oneOf(['default', 'primary', 'secondary', 'success', 'error', 'warning', 'info']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default EasyCheckIconButton; 